module.exports = __webpack_public_path__ + "img/jyj_wj_welcom_1_1.ee3d21ba.png";